module.exports = __webpack_public_path__ + "static/media/9-min.a49b97f6.png";